export default __webpack_public_path__ + "static/char-s-11-jp-e515cd573368199a07ecd80c04e6dc8b.png";